import React from 'react';
import { Link } from "react-router-dom";
import { Card, Tooltip } from 'antd'; // Import Tooltip from antd
import PropTypes from 'prop-types';

const cardStyle = {
  width: 52, // Adjust the width as necessary for the icon
  margin: '0 auto', // Center card in the available column space
  borderRadius: '11px', // Rounded corners for the card
  transition: 'transform 0.3s, box-shadow 0.3s', // Smooth transition for rotation and shadow effect
  background: '#000', // Glassmorphism-like background
  backdropFilter: 'blur(10px)', // Blur effect for glassmorphism
};

const iconStyle = {
  width: '100%', // Icon takes the full width of the card
  height: 'auto', // Keep aspect ratio
  borderRadius: '11px',
  backgroundSize: '100% 100%', // Cover the entire area of the card
    boxShadow: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px', // Inner and outer shadow for depth

};

const labelStyle = {
  marginTop: '8px',
  whiteSpace: 'nowrap',
  width: 100,
  textAlign: 'center',
  cursor: 'pointer', // Change cursor to indicate clickable
};

// Add a custom class for the hover effect in your CSS file
// .widget-hover:hover {
//   transform: rotate(-5deg) scale(1.05); // Example rotation and scale for 3D effect
//   box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 20px;
// }

const Widget = ({ config, color }) => {
  let style = { ...cardStyle }
  if (config.bg) {
    style.background = config.bg
  }


  return (
    <Link to={config.path} key={config.key}>
      <Tooltip title={config?.label} placement={'topRight'}> {/* Tooltip to show full label on hover */}
        <div
          style={{ textAlign: 'center', marginBottom: '10px', width: 100 }}
          className="widget-hover" // Apply hover effect
        >
          <Card
            hoverable
            className={'app-icon bg-black'}
            style={style}
            bodyStyle={{ padding: 0 }} // Removes padding inside the card
            cover={<img alt={config?.label} src={config?.iconUrl} style={iconStyle} />} // The icon image
          />
          <div className={'widget-title'} style={{...labelStyle, color: color}}>{config?.label}</div> {/* The label below the icon */}
        </div>
      </Tooltip>
    </Link>
  );
};

Widget.propTypes = {
  label: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  color: PropTypes.string,
};

export default Widget;
